import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import CallModal from './CallModal';

const { FiPhoneCall } = FiIcons;

export default function FloatingCallButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-6 right-6 z-50 p-4 bg-[#005b2d] text-white rounded-full shadow-xl hover:bg-[#004a25] transition-all hover:scale-110 active:scale-95 group focus:outline-none focus:ring-4 focus:ring-green-300"
        aria-label="Contact options"
      >
        <div className="absolute inset-0 rounded-full bg-[#005b2d] animate-ping opacity-75"></div>
        <SafeIcon icon={FiPhoneCall} className="text-2xl relative z-10" />
      </button>

      {isModalOpen && (
        <CallModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
}
